module.exports = __webpack_public_path__ + "img/kerry_new.de2144d1.png";